import { render, staticRenderFns } from "./notAuthentication.vue?vue&type=template&id=23ec24a6&scoped=true"
var script = {}
import style0 from "./notAuthentication.vue?vue&type=style&index=0&id=23ec24a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec24a6",
  null
  
)

export default component.exports